import React from 'react';
import valueone from "../../../assets/img/values-1.png";
import valuetwo from "../../../assets/img/values-2.png";
import valuethree from "../../../assets/img/values-3.png";
import { fadeInUp } from 'react-animations';
import Radium, { StyleRoot } from 'radium';
import { Link } from 'react-router-dom';




const styles = {
    fadeInUp: {
        animation: 'x 3s',
        animationName: Radium.keyframes(fadeInUp, 'fadeInUp')
    }

}

const Values = () => {
    return (
        <React.Fragment>
            <StyleRoot>
                <section id="values" className="values" style={styles.fadeInUp}>
                    <div className="container">
                        <header className="section-header">
                            <p>Feel safe and secure on Taskde</p>
                        </header>
                        <div className="row">
                            <div className="col-lg-4">
                                <div className="box">
                                    <img src={valueone} className="img-fluid" alt="" />
                                    <h3>Secure payments</h3>
                                    <p>Only release payment when the task is completed to your satisfaction</p>
                                    {/* <a className="valuelink" href="/">Learn more</a> */}
                                </div>
                            </div>
                            <div className="col-lg-4 mt-4 mt-lg-0">
                                <div className="box">
                                    <img src={valuetwo} className="img-fluid" alt="" />
                                    <h3>Trusted ratings and reviews</h3>
                                    <p>Pick the right person for the task based on real ratings and reviews from other users</p>
                                    {/* <a className="valuelink" href="/">Find out more</a> */}
                                </div>
                            </div>
                            <div className="col-lg-4 mt-4 mt-lg-0">
                                <div className="box">
                                    <img src={valuethree} className="img-fluid" alt="" />
                                    <h3>Insurance for peace of mind</h3>
                                    <p>We provide liability insurance for Taskers performing most task activities</p>
                                    {/* <a className="valuelink" href="/">See details</a> */}
                                </div>
                            </div>
                        </div>
                        <div className="row p-4">
                            <div className="col-lg-12">
                                <div className="text-center">
                                    <Link aria-current="page" className="btn-read-more d-inline-flex align-items-center justify-content-center align-self-center active" to="/signup">
                                        <span>Get started now for free </span> <i className="bi bi-arrow-right"></i>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </StyleRoot>
        </React.Fragment>
    )
}

export default Values;